module.exports = __webpack_public_path__ + "static/logo_mactenova_blanco-6e42da9b71f2aea667235eda87dae18e.png";